/**
 * Interfaces for modal functionality
 */

export interface OriginalElementState {
    ariaHidden: string | null;
    inert: boolean;
}

export interface AccessibleModalConfig {
    backdrop?: boolean | 'static';
    focus?: boolean;
    keyboard?: boolean;
}

export interface BootstrapModalInstance {
    show(relatedTarget?: Element): void;
    hide(): void;
    dispose(): void;
    toggle(relatedTarget?: Element): void;
}

export interface BootstrapModalConstructor {
    new(element: Element, config?: AccessibleModalConfig): BootstrapModalInstance;
    getInstance(element: Element): BootstrapModalInstance | null;
    getOrCreateInstance(element: Element, config?: AccessibleModalConfig): BootstrapModalInstance;
}

export interface DOMProvider {
    getBody(): HTMLElement;
    querySelector(selector: string): Element | null;
    querySelectorAll(selector: string): NodeListOf<Element>;
    appendChild(parent: Element, child: Element): void;
    removeChild(parent: Element, child: Element): void;
}

// Default DOM provider implementation
export class DefaultDOMProvider implements DOMProvider {
    getBody(): HTMLElement {
        return document.body;
    }

    querySelector(selector: string): Element | null {
        return document.querySelector(selector);
    }

    querySelectorAll(selector: string): NodeListOf<Element> {
        return document.querySelectorAll(selector);
    }

    appendChild(parent: Element, child: Element): void {
        parent.appendChild(child);
    }

    removeChild(parent: Element, child: Element): void {
        parent.removeChild(child);
    }
}

// Type declarations for Bootstrap global object
declare global {
    interface Window {
        bootstrap: {
            Modal: BootstrapModalConstructor;
        };
    }
    
    interface Element {
        inert?: boolean;
    }
}